import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import Layout from './layout'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import ContentLayout from '../../components/utility/layoutContent'
import ItemsContainer from './ItemsContainer'

const InquiryItemsPage = ({ match }) => {
    const { id } = match.params

    useEffect(() => {
        document.title = `${id} | OSH CRM`
    }, [id])

    return (
        <Layout>
            <LayoutContentWrapper breadcrumbs={
                [
                    { path: '/order_summaries', name: 'Orders' },
                    { path: `/inquiries/${id}`, name: id },
                    { path: `/inquiries/${id}/items`, name: 'Items' }
                ]
            }>
                <ContentLayout>
                    <ItemsContainer orderId={id} />
                </ContentLayout>
            </LayoutContentWrapper>
        </Layout>
    )
}

InquiryItemsPage.propTypes = {
    match: PropTypes.object.isRequired
}

export default InquiryItemsPage
